import React, { useState } from 'react';

import { useTheme } from 'contexts/ThemeContext';

import { isValidUrl } from 'utils/functions';

import { Text } from 'components/DataDisplay';
import { Modal } from 'components/Feedback';
import { Button, TextField } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';

const AddShopGroupModal = props => {
  const { handleClose, onNext = () => {} } = props;
  const { themeColors } = useTheme();

  const initialState = { name: '', key: '', googleSheetURL: '' };
  const ErrorState = {
    nameError: false,
    keyError: false,
    googleSheetURLError: false
  };
  const [{ name, key, googleSheetURL }, setState] = useState(initialState);
  const [
    { nameError, keyError, googleSheetURLError },
    setError
  ] = React.useState(ErrorState);

  const toggleError = (targetKey, state) => {
    setError(prevState => ({ ...prevState, [`${targetKey}Error`]: state }));
  };

  const handleChange = itemKey => value => {
    const text = typeof value === 'string' ? value.trim() : value;
    toggleError(itemKey, !text);
    if (itemKey === 'googleSheetURL') {
      toggleError('googleSheetURL', !isValidUrl(value));
    }
    setState(prevState => {
      const states = { ...prevState };
      states[itemKey] = text;
      return states;
    });
  };

  const resetStates = () => {
    setState(initialState);
    setError(ErrorState);
  };

  const handleNext = () => {
    let error = false;

    if (!name) {
      toggleError('name', true);
      error = true;
    }

    if (!key) {
      toggleError('key', true);
      error = true;
    }
    if (!googleSheetURL || googleSheetURLError) {
      toggleError('googleSheetURL', true);
      error = true;
    }
    if (!error) {
      onNext({ key, name, googleSheetURL });
      resetStates();
    }
  };

  return (
    <Modal
      scroll="paper"
      open
      bgColor={themeColors.themeV2.white}
      header={
        <Item
          flex
          style={{
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <Text
            variant="h6"
            align="center"
            fontWeight={700}
            color={themeColors.themeV2.subAccountTitle}
          >
            Créer un nouveau groupe de magasins
          </Text>
        </Item>
      }
      {...props}
      onClose={handleClose}
    >
      <Container>
        <Row>
          <Item xs={6}>
            <TextField
              title="Key"
              required
              small
              value={key}
              onChange={handleChange('key')}
              error={keyError}
            />
          </Item>
          <Item xs={6}>
            <TextField
              title="Nom"
              small
              required
              value={name}
              onChange={handleChange('name')}
              error={nameError}
            />
          </Item>
          <Item>
            <TextField
              title="URL du Google Sheet"
              required
              small
              value={googleSheetURL}
              onChange={handleChange('googleSheetURL')}
              error={googleSheetURLError}
            />
          </Item>
        </Row>
        <Row justifyContent="flex-end">
          <Item xs={2}>
            <Button
              onClick={handleNext}
              variant="contained"
              justify="center"
              style={{
                padding: '10px 16px'
              }}
            >
              <Text fontSize="inherit" fontWeight="inherit" color="inherit">
                Créer
              </Text>
            </Button>
          </Item>
        </Row>
      </Container>
    </Modal>
  );
};

export default AddShopGroupModal;
